import {
  Job,
  RemoveTrackedQuery,
  TrackedMedia,
  TrackedQuery,
} from '@ih/app/client/shared/interfaces';
import Dexie, { Table } from 'dexie';

export class AppDB extends Dexie {
  trackedQuery!: Table<TrackedQuery, string>;
  removeTrackedQuery!: Table<RemoveTrackedQuery, string>;
  trackedMedia!: Table<TrackedMedia | null, string>;
  downloadedForms!: Table<any>;
  downloadedSharedForms!: Table<any>;
  queriesCache!: Table<Job>;
  formDrafts!: Table<any, string>;

  constructor() {
    super('localDB');
    this.version(3).stores({
      trackedQuery: 'trackId',
      removeTrackedQuery: 'trackId',
      trackedMedia: 'trackId',
      downloadedForms: 'id',
      downloadedSharedForms: 'id',
      queriesCache: 'jobId',
    });
    // v4: per-user in-progress form drafts (BUG/feature: forms-save-resume)
    this.version(4).stores({
      trackedQuery: 'trackId',
      removeTrackedQuery: 'trackId',
      trackedMedia: 'trackId',
      downloadedForms: 'id',
      downloadedSharedForms: 'id',
      queriesCache: 'jobId',
      formDrafts: 'id, userId',
    });
  }
}
export const db = new AppDB();
